import { useNavigate } from 'react-router-dom';
import { usePromoBanner } from '../../contexts/PromoBannerContext';

const PromoBanner = () => {
  const { bannerVisible, dismiss } = usePromoBanner();
  const navigate = useNavigate();

  return (
    <div
      className="w-full bg-[#0C2340] overflow-hidden transition-all duration-300"
      style={{ maxHeight: bannerVisible ? '44px' : '0px', opacity: bannerVisible ? 1 : 0 }}
    >
      <div className="h-11 flex items-center justify-between px-4 lg:px-8">
        {/* Spacer — keeps content centered on desktop */}
        <div className="hidden lg:block w-28 flex-shrink-0" />

        {/* Center message */}
        <div className="flex items-center space-x-2.5 flex-1 justify-center min-w-0">
          <span className="text-white text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis">
            Spring AC Tune-Up &mdash;{' '}
            <strong className="font-bold">Only $49</strong>
            <span className="hidden sm:inline text-white/55"> &middot; Limited Time</span>
          </span>
          <button
            onClick={() => navigate('/book-appointment')}
            className="bg-[#C41E3A] text-white text-xs font-bold px-3 py-1 rounded-full hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            Book Now
          </button>
        </div>

        {/* Dismiss */}
        <div className="w-28 flex justify-end flex-shrink-0">
          <button
            onClick={dismiss}
            className="w-7 h-7 flex items-center justify-center text-white/40 hover:text-white transition-colors cursor-pointer rounded-full hover:bg-white/10"
            aria-label="Dismiss promotion"
          >
            <i className="ri-close-line text-sm" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoBanner;
